export default __webpack_public_path__ + "static/media/quickstart2-3.1b6842fc.svg";